import { dew as _AbstractTimeExpressionParserDew } from "../../../common/parsers/AbstractTimeExpressionParser";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  const AbstractTimeExpressionParser_1 = _AbstractTimeExpressionParserDew();
  class NLTimeExpressionParser extends AbstractTimeExpressionParser_1.AbstractTimeExpressionParser {
    primaryPrefix() {
      return "(?:(?:om)\\s*)?";
    }
    followingPhase() {
      return "\\s*(?:\\-|\\\u2013|\\~|\\\u301C|om|\\?)\\s*";
    }
    primarySuffix() {
      return "(?:\\s*(?:uur))?(?!/)(?=\\W|$)";
    }
    extractPrimaryTimeComponents(context, match) {
      if (match[0].match(/^\s*\d{4}\s*$/)) {
        return null;
      }
      return super.extractPrimaryTimeComponents(context, match);
    }
  }
  exports.default = NLTimeExpressionParser;
  //# sourceMappingURL=NLTimeExpressionParser.js.map
  return exports;
}